import { gql } from "@apollo/client";

export const addSupplierPaymentDetails = gql`
mutation AddSupplierPaymentDetails($input: addSupplierPaymentInput) {
  addSupplierPaymentDetails(input: $input)
}`;
export const updateSupplierPaymentDetails = gql`
mutation UpdateSupplierPayment($input: UpdateSupplierPaymentInput) {
  updateSupplierPayment(input: $input) {
    id
  }
}
`;

export const returnCheckoutLink = gql`
mutation MakeExternalPayment($input: MakePaymentInput!) {
  makeExternalPayment(input: $input)
}
`;

export const requestPayout = gql`
mutation MakeWalletWithdrawal($input: WalletWithdrawalInput!) {
  makeWalletWithdrawal(input: $input) {
    reference
    status
    error
    metadata
  }
}
`;

export const cardSetup = gql`
mutation InitiateCardSetup($input: InitiateCardSetupInput) {
  initiateCardSetup(input: $input)
}
`